import { Component, Inject, Injectable, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { de, es } from 'date-fns/locale';
import { HttpService } from 'src/app/services/http.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { URLUtils } from 'src/app/urlUtils';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-share-documents-dialog',
    templateUrl: './share-documents-dialog.component.html',
    styleUrls: ['./share-documents-dialog.component.scss'],
    standalone: false
})

export class ShareDocumentsDialogComponent {
  searchForm: FormGroup;
  selectedCategories: any[] = [];
  searchText: any = '';
  files: any[] = [];
  selectedDocs: any[] = [];
  getTagId: any;
  allFiles: any[] = [];
  getCatgory: any[] = [
    { id: 'client', title: 'Client' },
    { id: 'firm', title: 'Firm' }
  ];
  nogetCatgory: any[] = [
    { id: 'client', title: 'Client' },
  ];
  catsolo:any;
  noDocumentsFound = false;
  viewClientDocuments: boolean = true;
  viewFirmDocuments: boolean = false;
  clientDocuments: any = [];
  firmDocuments: any = [];
  allDocs: any = [];
  isLoading = false;

  constructor(
    private fb: FormBuilder, private authService: HttpService, public toast: ToastrService, public send_menu_request_dialog: MatDialog,
    private dialogRef: MatDialogRef<ShareDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public spinnerService :NgxSpinnerService
  ) {
    this.searchForm = this.fb.group({
      categories: [null, Validators.required],
      searchQuery: ['']
    });

  }

  ngOnInit() {
    this.catsolo = localStorage.getItem('category');

    //console.log('share data:', this.data);
    const defaultCategory = this.categoryList.find(
      cat => cat.id === (this.data?.category || 'client')
    );

    if (defaultCategory) {
      this.searchForm.get('categories')?.setValue(defaultCategory);
      this.loadDocuments(defaultCategory.id);
    }
  }
  get categoryList() {
    return this.catsolo === 'solo'
      ? this.nogetCatgory   // only Client
      : this.getCatgory;    // Client + Firm
  }

  getDoctypeName(doctype: any): any {
    // console.log('Getting doctype name for:', doctype);
    return doctype;
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return ''; // empty string

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return ''; // invalid date

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
  }

  // formatSize(sizeInBytes: number): string {
  //   return `${Math.ceil(sizeInBytes / 1024)} KB`;  // or use MB if needed
  // }

  formatSize(sizeInBytes?: number): string {
    return sizeInBytes
      ? `${Math.ceil(sizeInBytes / 1024)} KB`
      : '-';
  }



  loadDocuments(category: string) {

    if (category === 'client') {
      this.loadClientDocuments();
    }
    else if (category === 'firm') {
      this.loadFirmDocuments();
    }
  }
  onCategoryChange(categoryObj: any) {
    if (!categoryObj) {
      this.allFiles = [];
      return;
    }

    this.loadDocuments(categoryObj.id);
  }

  loadClientDocuments() {
    const payload = {
      category: "client",
      clients: this.data.id,
      matters: "all",
      relationship_id: this.data.relid, 
      exclude_already_shared: true
    };

    // this.spinnerService.show();
      this.isLoading = true;
    this.authService.sendPutRequest(URLUtils.getFilteredDocuments, payload)
      .subscribe({
        next: (res: any) => {
          // this.spinnerService.hide();
           this.isLoading = false;
          this.clientDocuments = res?.data || [];
          this.files = [...this.clientDocuments];     // IMPORTANT
          this.allFiles = [...this.clientDocuments];  // IMPORTANT
        },
        error: (err) => {
        this.isLoading = false;
        this.handleError(err);
      }
      });
  }

  loadFirmDocuments() {
    const payload = { category: "firm" };

    //this.spinnerService.show();
      this.isLoading = true;
    this.authService.sendPutRequest(URLUtils.getFilteredDocuments, payload)
      .subscribe({
        next: (res: any) => {
          // this.spinnerService.hide();
           this.isLoading = false;
          this.firmDocuments = res?.data || [];
          this.files = [...this.firmDocuments];     // IMPORTANT
          this.allFiles = [...this.firmDocuments];  // IMPORTANT
        },
        error: (err) => {
        this.isLoading = false;
        this.handleError(err);
      }
      });
  }


  onSearch(): void {
    const query = this.searchForm.get('searchQuery')?.value?.toLowerCase() || '';

    if (!query) {
      this.allFiles = [...this.files];
      return;
    }

    this.allFiles = this.files.filter(file =>
      file.filename?.toLowerCase().includes(query) ||
      file.name?.toLowerCase().includes(query)
    );
  }

  handleError(error: HttpErrorResponse) {
    if (error.status === 401 || error.status === 403) {
      const errorMessage = error.error?.msg || 'Unauthorized';
      this.toast.error(errorMessage);
    } else {
      this.toast.error('Something went wrong');
    }
  }

  onCountryChange(country: any) {
    //console.log('onChange country', country)
    this.searchForm.patchValue({ country }, { emitEvent: false });
    //this.loadDocuments();
  }

  compareCategory = (c1: any, c2: any) => {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  };   // to compare two category objects

  sendRequest(connection: any) {
    this.dialogRef.close({
      ...connection,
      categories: this.selectedCategories
    });
  }


  onShare() {
  let selectedCategory = this.searchForm.get('categories')?.value;

  if (!selectedCategory) {
    this.toast.error("Please select category");
    return;
  }

  if (this.selectedDocs.length === 0) {
    this.toast.error("Please select at least one document");
    return;
  }
  // console.log('this.selectedDocs',this.selectedDocs)
  this.dialogRef.close({
    selectedDocs: this.selectedDocs,   // send selected documents
    category: selectedCategory.id      // optional if needed
  });
}

  onCancel() {
    this.dialogRef.close();
  }

  capitalizeFirstLetter(status: string): string {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }

  toggleSelection(file: any, event: Event) {
    const input = event.target as HTMLInputElement;
    const checked = input?.checked;
    const docObj = { docid: file.id, doctype: "general", matters: file.matters };
    // console.log('Toggling selection for:', docObj, 'Checked:', checked);
    // console.log('Current selectedDocs2:', this.selectedDocs);

    if (checked) {
      this.selectedDocs.push(docObj);
    } 
    // else {
    //   this.selectedDocs = this.selectedDocs.filter(
    //     doc => doc.docid !== file.id || doc.doctype !== file.doctype
    //   );
    // }
  }

  isSelected(fileId: any): boolean {
    return this.selectedDocs.some(doc => doc.docid === fileId);
  }

  getMatterNames(doc: any): string {
    return doc.matter_details?.map((item: any) => item.name).join(', ');
  }
}

